import sumBy from 'lodash/sumBy'

import type { PaymentStatus } from 'modules/payroll_bundle/components/common/components/ShowStatus'
import { PAID } from 'modules/payroll_bundle/lib/constants'
import type { Payments } from 'modules/payroll_bundle/store/collections/payments'
import type PaymentItem from 'modules/payroll_bundle/store/models/PaymentItem'

import { formatAmount } from './formatNumber'

function getPaymentStatus(paymentItem: PaymentItem, payments: Payments): PaymentStatus | null {
  return payments.get(paymentItem.attributes.payment_id)?.attributes.status
}

function getPaymentCreatedAt(paymentItem: PaymentItem, payments: Payments): string | null {
  return payments.get(paymentItem.attributes.payment_id)?.attributes.created_at
}

function getAmountInCents(paymentItem: PaymentItem): number {
  return paymentItem.attributes.amount_in_cents
}

function getAmountInCentsFormatted(paymentItem: PaymentItem, currency: string): string {
  return formatAmount(getAmountInCents(paymentItem), currency)
}

function getPaidPaymentItems(paymentItems: PaymentItem[], payments: Payments): PaymentItem[] {
  return paymentItems.filter((paymentItem) => getPaymentStatus(paymentItem, payments) === PAID)
}

function sumPaymentItems(paymentItems: PaymentItem[]): number {
  return sumBy(paymentItems, (paymentItem) => paymentItemLib.getAmountInCents(paymentItem))
}

export const paymentItemLib = {
  getPaymentStatus,
  getPaymentCreatedAt,
  getAmountInCents,
  getAmountInCentsFormatted,
  getPaidPaymentItems,
  sumPaymentItems,
}
